import axios from '@/utils/request'
/**
 * 公众号概况
 */

export const getWx_statistics = (params)=>{
  return axios.request({
     url: 'v1/wx_statistics/index',
     method: 'get',
     params
   })
 };
// 获取粉丝标签列表
export const getTagList = (params)=>{
 return axios.request({
    url: 'v1/wx_user/tagsList',
    method: 'get',
    params
  })
};
// 指定标签的粉丝列表
export const getTagUserList = (params)=>{
  return axios.request({
     url: 'v1/wx_user/tagsUserList',
     method: 'get',
     params
   })
 };
// 添加粉丝标签
export const createTags = (params)=>{
  return axios.request({
    url: 'v1/wx_user/createTags',
    method: 'post',
    params
  })
};
// 粉丝列表
export const getFansList = (params)=>{
  return axios.request({
    url: 'v1/wx_user/userList',
    method: 'get',
    params
  })
};
// 修改粉丝备注
export const setFansRemarks = (data)=>{
  return axios.request({
    url: 'v1/wx_user/userRemarks',
    method: 'POST',
    data
  })
};
// 修改粉丝标签
export const setFansSaveTags = (data)=>{
  return axios.request({
    url: 'v1/wx_user/saveTags',
    method: 'POST',
    data
  })
};
// 删除粉丝标签
export const delFansSaveTags = (data)=>{
  return axios.request({
    url: 'v1/wx_user/deleteTags',
    method: 'POST',
    data
  })
};
// 为粉丝打标签
export const setFansTag = (data)=>{
  return axios.request({
    url: 'v1/wx_user/setUserTag',
    method: 'post',
    data
  })
};

// 素材管理-微信图文-图文列表
export const getWxGraphic = (params)=>{
  return axios.request({
    url: 'v1/wx_graphic/index',
    method: 'get',
    params
  })
};
// 素材管理-微信图文-图文详情
export const getWxGraphicMore = (params)=>{
  return axios.request({
    url: 'v1/wx_graphic/detail',
    method: 'get',
    params
  })
};
// 素材管理-微信图文-创建图文
export const wxGraphicAdd = (data)=>{
  return axios.request({
    url: 'v1/wx_graphic/create',
    method: 'POST',
    data
  })
};
// 素材管理-微信图文-修改图文
export const wxGraphicEdit = (data)=>{
  return axios.request({
    url: 'v1/wx_graphic/save',
    method: 'POST',
    data
  })
};
// 素材管理-微信图文-删除图文
export const wxGraphicDel = (data)=>{
  return axios.request({
    url: 'v1/wx_graphic/delete',
    method: 'POST',
    data
  })
};

// 素材管理-高级图文-高级图文列表
export const getWxGraphicSenior = (params)=>{
  return axios.request({
    url: 'v1/wx_graphic_senior/index',
    method: 'get',
    params
  })
};
// 素材管理-高级图文-高级图文详情
export const getWxGraphicSeniorMore = (params)=>{
  return axios.request({
    url: 'v1/wx_graphic_senior/detail',
    method: 'get',
    params
  })
};
// 素材管理-高级图文-创建高级图文
export const wxGraphicSeniorAdd = (data)=>{
  return axios.request({
    url: 'v1/wx_graphic_senior/create',
    method: 'POST',
    data
  })
};
// 素材管理-高级图文-修改高级图文
export const wxGraphicSeniorEdit = (data)=>{
  return axios.request({
    url: 'v1/wx_graphic_senior/save',
    method: 'POST',
    data
  })
};
// 素材管理-高级图文-删除高级图文
export const wxGraphicSeniorDel = (data)=>{
  return axios.request({
    url: 'v1/wx_graphic_senior/delete',
    method: 'POST',
    data
  })
};

// 素材管理-小程序卡片-小程序卡片列表
export const getMiniCard = (params)=>{
  return axios.request({
    url: 'v1/wx_minicard/index',
    method: 'get',
    params
  })
};
// 素材管理-小程序卡片-小程序卡片详情
export const getMiniCardMore = (params)=>{
  return axios.request({
    url: 'v1/wx_minicard/detail',
    method: 'get',
    params
  })
};
// 素材管理-小程序卡片-创建小程序卡片
export const miniCardAdd = (data)=>{
  return axios.request({
    url: 'v1/wx_minicard/create',
    method: 'POST',
    data
  })
};
// 素材管理-小程序卡片-修改小程序卡片
export const miniCardEdit = (data)=>{
  return axios.request({
    url: 'v1/wx_minicard/save',
    method: 'POST',
    data
  })
};
// 素材管理-小程序卡片-删除小程序卡片
export const miniCardDel = (data)=>{
  return axios.request({
    url: 'v1/wx_minicard/delete',
    method: 'POST',
    data
  })
};
//消息管理- 消息列表
export const getWx_msg = (params)=>{
  return axios.request({
    url: 'v1/wx_msg/index',
    method: 'get',
    params
  })
};
// 消息管理-收藏消息
export const setWx_msgCollection = (data)=>{
  return axios.request({
    url: 'v1/wx_msg/collection',
    method: 'POST',
    data
  })
};
// 消息管理-回复消息
export const setWx_msgReply = (data)=>{
  return axios.request({
    url: 'v1/wx_msg_reply/reply',
    method: 'POST',
    data
  })
};
//消息管理- 聊天记录列表
export const getWx_msgChatRecord = (params)=>{
  return axios.request({
    url: 'v1/wx_msg_reply/chatRecord',
    method: 'get',
    params
  })
};
/**
 * 公众号功能
 */

//公众号菜单
export const getwx_facility = ()=>{
  return axios.request({
    url: 'v1/wx_facility/getMemu',
    method: 'get'
  })
};
//保存公总号菜单
export const savewx_facility = (data)=>{
  return axios.request({
    url: 'v1/wx_facility/saveMenu',
    method: 'POST',
    data
  })
};
//发布公总号菜单
export const setwx_facility = (data)=>{
  return axios.request({
    url: 'v1/wx_facility/createMenu',
    method: 'POST',
    data
  })
};

// 小程序页面路径列表
export const getMiniPage = ()=>{
  return axios.request({
    url: 'v1/page/list?type=1',
    method: 'get'
  })
};

//保存消息回复设置
export const setwx_reply = (data)=>{
  return axios.request({
    url: 'v1/wx_reply/save',
    method: 'POST',
    data
  })
};
//获取自动回复设置
export const getwx_reply = (params)=>{
  return axios.request({
    url: 'v1/wx_reply/detail',
    method: 'get',
    params
  })
};
//关键词自动回复-规则列表
export const getwx_Keyreply = (params)=>{
  return axios.request({
    url: 'v1/wx_key_reply/index',
    method: 'get',
    params
  })
};
//关键词自动回复-添加规则
export const wx_KeyreplyAdd = (data)=>{
  return axios.request({
    url: 'v1/wx_key_reply/create',
    method: 'post',
    data
  })
};
//关键词自动回复-修改规则
export const wx_KeyreplyEdit = (data)=>{
  return axios.request({
    url: 'v1/wx_key_reply/save',
    method: 'post',
    data
  })
};
//关键词自动回复-删除规则
export const wx_KeyreplyDel = (data)=>{
  return axios.request({
    url: 'v1/wx_key_reply/delete',
    method: 'post',
    data
  })
};
//关键词自动回复-规则详情
export const getwx_KeyreplyMore = (params)=>{
  return axios.request({
    url: 'v1/wx_key_reply/detail',
    method: 'get',
    params
  })
};
//带参数二维码分类列表
export const getwx_qrcode_cate = (params)=>{
  return axios.request({
    url: 'v1/wx_qrcode_cate/index',
    method: 'get',
    params
  })
};
//删除带参数二维码分类
export const wx_qrcode_cateDel = (data)=>{
  return axios.request({
    url: 'v1/wx_qrcode_cate/delete',
    method: 'POST',
    data
  })
};
//创建带参数二维码分类
export const wx_qrcode_cateAdd = (data)=>{
  return axios.request({
    url: 'v1/wx_qrcode_cate/create',
    method: 'POST',
    data
  })
};
//修改带参数二维码分类
export const wx_qrcode_cateEdit = (data)=>{
  return axios.request({
    url: 'v1/wx_qrcode_cate/save',
    method: 'POST',
    data
  })
};

//带参数二维码列表
export const getwx_qrcode = (params)=>{
  return axios.request({
    url: 'v1/wx_qrcode/index',
    method: 'get',
    params
  })
};
//带参数二维码详情
export const getwx_qrcodeMore = (params)=>{
  return axios.request({
    url: 'v1/wx_qrcode/detail',
    method: 'get',
    params
  })
};
//修改带参数二维码状态
export const wx_qrcode_status = (data)=>{
  return axios.request({
    url: 'v1/wx_qrcode/status',
    method: 'POST',
    data
  })
};
//修改带参数二维码
export const wx_qrcode_Edit = (data)=>{
  return axios.request({
    url: 'v1/wx_qrcode/save',
    method: 'POST',
    data
  })
};
//创建带参数二维码
export const wx_qrcode_Add = (data)=>{
  return axios.request({
    url: 'v1/wx_qrcode/create',
    method: 'POST',
    data
  })
};
//删除带参数二维码
export const wx_qrcodeDel = (data)=>{
  return axios.request({
    url: 'v1/wx_qrcode/delete',
    method: 'POST',
    data
  })
};
/**
 * 系统设置-微信
 */

//微信绑定授权
export const getWx_authorize = ()=>{
  return axios.request({
    url: 'v1/wx_authorize/index',
    method: 'get'
  })
};
//授权公众号添加
export const setWx_authorize = (data)=>{
  return axios.request({
    url: 'v1/wx_authorize/create',
    method: 'POST',
    data
  })
};
//授权公众号修改
export const editWx_authorize = (data)=>{
  return axios.request({
    url: 'v1/wx_authorize/save',
    method: 'POST',
    data
  })
};
//获取微信接口配置
export const getWx_config = ()=>{
  return axios.request({
    url: 'v1/wx_config/config',
    method: 'get'
  })
};
//保存微信接口配置
export const setWx_config = (data)=>{
  return axios.request({
    url: 'v1/wx_config/configSave',
    method: 'POST',
    data
  })
};
/**
 * 小程序配置-微信
 */

//小程序配置信息
export const getWxApplets = ()=>{
  return axios.request({
    url: 'v1/wx_applets/config',
    method: 'get'
  })
};
//小程序保存配置信息
export const setWxApplets = (data)=>{
  return axios.request({
    url: 'v1/wx_applets/configSave',
    method: 'POST',
    data
  })
};

//微信图片素材列表
export const getwx_material = (params)=>{
  return axios.request({
    url: 'v1/wx_material/index',
    method: 'get',
    params
  })
};
//新建微信图片
export const createwx_material = (data)=>{
  return axios.request({
    url: 'v1/wx_material/create',
    method: 'post',
    data
  })
};
//修改图片素材
export const editwx_material = (data)=>{
  return axios.request({
    url: 'v1/wx_material/save',
    method: 'post',
    data
  })
};
//删除图片素材
export const delwx_material = (data)=>{
  return axios.request({
    url: 'v1/wx_material/delete',
    method: 'post',
    data
  })
};

//微信图片分类列表
export const getwx_material_cate = (params)=>{
  return axios.request({
    url: 'v1/wx_material_cate/index',
    method: 'get',
    params
  })
};
//删除微信图片分类
export const delwx_material_cate = (data)=>{
  return axios.request({
    url: 'v1/wx_material_cate/delete',
    method: 'post',
    data
  })
};
//修改微信图片分类
export const editwx_material_cate = (data)=>{
  return axios.request({
    url: 'v1/wx_material_cate/save',
    method: 'post',
    data
  })
};
//微信图片分类列表
export const createwx_material_cate = (data)=>{
  return axios.request({
    url: 'v1/wx_material_cate/create',
    method: 'post',
    data
  })
};

//微信同步
export const setSynchro= (data)=>{
  return axios.request({
    url: 'v1/wx_synchro/synchro',
    method: 'post',
    data
  })
};
//微信同步记录
export const getSynchroRecord = (params)=>{
  return axios.request({
    url: 'v1/wx_synchro/synchroRecord',
    method: 'get',
    params
  })
};
// 图片素材-校验图片是否已在公众号删除

export const wx_materialCheck = (params)=>{
  return axios.request({
    url: 'v1/wx_material/check',
    method: 'get',
    params
  })
};
// 图文素材-校验图文是否已在公众号删除

export const wx_graphicCheck = (params)=>{
  return axios.request({
    url: 'v1/wx_graphic/check',
    method: 'get',
    params
  })
};



// 音频素材-列表
export const wxMaterialVoice = (params)=>{
  return axios.request({
    url: 'v1/wxMaterialVoice',
    method: 'get',
    params
  })
};

// 音频素材-修改
export const editWxMaterialVoice = (data)=>{
  return axios.request({
    url: 'v1/wxMaterialVoice/'+data.id,
    method: 'post',
    data
  })
};

// 音频素材-删除
export const delWxMaterialVoice = (data)=>{
  return axios.request({
    url: 'v1/wxMaterialVoice/'+data.id,
    method: 'delete',
    data
  })
};




// 视频素材-列表
export const wxMaterialVideo = (params)=>{
  return axios.request({
    url: 'v1/wxMaterialVideo',
    method: 'get',
    params
  })
};

// 视频素材-删除
export const delWxMaterialVideo = (data)=>{
  return axios.request({
    url: 'v1/wxMaterialVideo/'+data.id,
    method: 'delete',
    data
  })
};


// 音频素材-上传
export const uploadWxMaterialVoice = (data)=>{
  return axios.request({
    url: 'v1/wxMaterialVoice',
    method: 'post',
    data
  })
};


// 音频素材-音频详情
export const getWxMaterialVoice = (params)=>{
  return axios.request({
    url: 'v1/wxMaterialVoice/detail',
    method: 'get',
    params
  })
};

// 图片详情
export const getWxMaterial = (params)=>{
  return axios.request({
    url: 'v1/wx_material/detail',
    method: 'get',
    params
  })
};

// 视频详情
export const getWxMaterialVideo = (params)=>{
  return axios.request({
    url: 'v1/wxMaterialVideo/detail',
    method: 'get',
    params
  })
};

//获取appid
export const getAppID = (params)=>{
  return axios.request({
    url: 'v1/miniapp_authorize/index',
    method: 'get',
    params
  })
};








